/**
 * SFN i18n — English (source of truth).
 * All other locales spread this dict as their base, then override.
 */
import type { Dict } from "./types";

export const en: Dict = {
  "nav.home": "Home",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.ecosystem": "Ecosystem",
  "nav.tokens": "Tokens",
  "nav.protection": "Protection",
  "nav.secure": "Secure",
  "nav.faq": "FAQ",
  "hero.eyebrow": "Verified $1 Inflation Protection on Solana",
  "hero.stat1": "Meals secured",
  "hero.stat2": "Real assets backing",
  "hero.stat3": "Avg. settlement",
  "bento.title": "The Sustainable Food & Eco Network (SFN): How It Works",
  "bento.sub": "Tokenomics, utility, and resilience — composed like a tasting menu.",
  "bento.live": "Live supply",
  "bento.live.d": "Real-time circulating Meal4 and Meal2, on-chain transparent.",
  "bento.kitchen": "Anchor kitchen",
  "bento.kitchen.d": "Operating pilot kitchen in the Thailand Sandbox — meals served daily.",
  "bento.assets": "Real estate backing",
  "bento.assets.d": "Land and buildings collateralize the stabilizer pool.",
  "bento.audit": "Audited reserves",
  "bento.audit.d": "Quarterly proof-of-reserves and supply attestation.",
  "bento.uptime": "Network uptime",
  "bento.community": "Community holders",
  "bento.card1.title": "The Vision & Network (SFN)",
  "bento.card1.text":
    "SFN is an open, decentralized network of certified partner kitchens, local farmers, and supporters. By uniting community funding and solar-powered operations, we keep food production costs unbeatably low and stable.",
  "bento.card2.title": "Decentralized Regional Sourcing Hub",
  "bento.card2.text":
    "Our anchor operations function as a live, real-world testing ground where the 30 THB meal framework is proven daily. From this hub we coordinate bulk ingredient sourcing, solar-powered kitchen infrastructure, and the operational standards that every partner location inherits.",

  "bento.card3.title": "Scalable Global Impact",
  "bento.card3.text":
    "We don't stop at one kitchen. SFN is designed to grow. International supporters can sponsor meals digitally, while traditional local garkuchens can join our network to access subsidized ingredients and solar energy.",

  "milestones.eyebrow": "IMMEDIATE ROADMAP: BRIDGING BLOCKCHAIN WITH PHYSICAL INFRASTRUCTURE",
  "milestones.p1.title": "The SFN Central Kitchen Hub (Thailand Sandbox)",
  "milestones.p1.desc":
    "Financed by institutional capital, our upcoming automated central processing facility will handle bulk ingredient sourcing, solar-powered refrigeration, and zero-waste meal preparation. This eliminates middleman costs and guarantees price stability before distribution.",
  "milestones.p1.target": "100% Solar-Powered Supply Chain Interconnection.",
  "milestones.p2.title": "Hyper-Expansion of Smart Express Branches",
  "milestones.p2.desc":
    "Scaling our proven gastronomy framework from the initial anchor location into a regional network of high-efficiency express food branches across key high-traffic corridors. Each branch operates on subsidized zero-cost energy grids.",
  "milestones.p2.target": "Multi-Location Regional Sandbox Rollout.",

  "pilot.eyebrow": "Live Pilot Proof of Concept: Thailand Sandbox",
  "pilot.title": "Thailand: Phase 1 Pilot Market (Sandbox Zone)",
  "pilot.body":
    "Launching inside a high-efficiency regional market lets us stress-test the MEAL4 / MEAL2 tokenomics and the real-world supply chain with maximum operational control. Every kitchen, every ingredient flow, and every settlement path is validated in a contained environment before SFN executes its international rollout.",
  "pilot.benchmark.label": "$1 Global Benchmark",
  "pilot.benchmark.value": "$1",
  "pilot.benchmark.desc":
    "We anchor meal prices at or below $1 USD — locally fixed at 30 THB per meal — using localized Web3 mechanics designed to prove global scalability.",
  "pilot.phase1": "Phase 1: Regional Pilot ($1 Target)",
  "pilot.phase2": "Phase 2: Global Scalability",
  "pilot.phase.arrow": "Roadmap path",
  "pilot.stat1.label": "Pilot market",
  "pilot.stat1.value": "Thailand Sandbox",
  "pilot.stat2.label": "Meal anchor",
  "pilot.stat2.value": "$1",
  "pilot.stat3.label": "Next phase",
  "pilot.stat3.value": "Global rollout",

  "about.eyebrow": "Founders & Mission",
  "about.titleA": "Behind the",
  "about.titleB": "Sustainable Food & Eco Network",
  "about.body":
    "SFN was founded by an entrepreneurial team bridging classical German business administration and real-world Thai gastronomy. Witnessing the direct impact of global inflation on local communities, we decided to weaponize blockchain technology not for speculation, but for basic human stability. Our pilot kitchen in Thailand, Thailand, serves as the operational blueprint for a transparent, solar-powered, and decentralized future of food security.",

  "contact.eyebrow": "Partnership Inquiry",
  "contact.titleA": "Join the",
  "contact.titleB": "Network",
  "contact.body":
    "Are you a local kitchen looking to accept MEAL tokens, a farmer wanting to supply us directly, or an international supporter with questions? Reach out to us.",
  "contact.name": "Name",
  "contact.namePh": "Your name",
  "contact.email": "Email",
  "contact.emailPh": "you@example.com",
  "contact.subject": "Subject",
  "contact.subjectPh": "Partnership, supply, support…",
  "contact.message": "Message",
  "contact.messagePh": "Tell us about your project or question…",
  "contact.sent": "Message securely transmitted",
  "contact.successBody":
    "Your message has been routed through our encrypted endpoint. A team member will reach out within 48 hours.",
  "contact.errorTitle": "Transmission failed",
  "contact.errorBody":
    "We couldn't deliver your message. Please check your connection and try again.",
  "contact.dismissOk": "Send another",
  "contact.dismissError": "Retry",
  "contact.responseNote": "We typically respond within 48 hours.",
  "contact.send": "Send Message",



  "dual.eyebrow": "Dual-Token Architecture",
  "dual.title": "Our Dual-Token System: Security Meets Utility",
  "dual.sub":
    "Meal4 moves value. Meal2 keeps it still. Together they make food security spendable.",
  "dual.meal4.role": "Inflation Shield",
  "dual.meal4.t": "MEAL4 \u2013 The Inflation Shield",
  "dual.meal4.d":
    "Strictly limited to 1,000,000 tokens with no option to ever create more. MEAL4 acts as a digital contract backed by physical asset reserves and strategic bulk-purchasing power. It freezes the cost of food production at its core, creating a deflationary hedge against rising market prices.",
  "dual.meal4.b1": "1,000,000 tokens \u2014 never more",
  "dual.meal4.b2": "Backed by real asset reserves",
  "dual.meal4.b3": "Deflationary hedge against inflation",
  "dual.meal2.role": "Daily Utility",
  "dual.meal2.t": "MEAL2 \u2013 The Daily Utility",
  "dual.meal2.d":
    "The practical everyday token designed for smooth restaurant operations, rewards, and community aid. MEAL2 drives the ecosystem by enabling instant mobile payments, loyalty discounts for local guests, and transparent digital meal sponsorships from global supporters.",
  "dual.meal2.b1": "Instant mobile payments",
  "dual.meal2.b2": "Loyalty discounts & rewards",
  "dual.meal2.b3": "Transparent digital meal sponsorships",
  "dual.flow": "Energy Flow",
  "dual.flow.d": "Meal2 reserves continuously stabilize Meal4 — like sauce to a dish.",
  "protection.eyebrow": "Immutable Security · On-Chain",
  "protection.title": "Irrevocable Trust Built Into Code",
  "protection.sub":
    "We have hardcoded strict security parameters directly into our smart contracts, protecting the community from inflation and unauthorized changes.",
  "protection.f1.title": "100% Frozen-Proof Assets",
  "protection.f1.text":
    "The 'Freeze Authority' has been permanently revoked for both tokens. No central power, institution, or developer can ever freeze your wallet or stop you from using your MEAL tokens.",
  "protection.f2.title": "Hardcoded Supply Cap (MEAL4)",
  "protection.f2.text":
    "The 'Mint Authority' for MEAL4 has been irrevocably destroyed. It is mathematically impossible to ever print more than 1,000,000 MEAL4 tokens, permanently protecting your food security hedge from devaluation.",
  "protection.f3.title": "Flexible Utility Growth (MEAL2)",
  "protection.f3.text":
    "We intentionally retained the minting capabilities for MEAL2 to scale seamlessly with new partner kitchens joining the Sustainable Food & Eco Network, ensuring local economies always have enough transactional fuel.",
  "swap.eyebrow": "Token Sale",
  "swap.title": "Secure Your Meals",
  "swap.sub":
    "Swap directly into Meal4. Each token guarantees one meal at our partner kitchen — today, tomorrow, after any crisis.",
  "swap.from": "You Send",
  "swap.to": "Estimated Meals Secured",
  "swap.balance": "Balance",
  "swap.quoting": "Calculating price impact…",
  "swap.meal4.cta": "Contribute Now",
  "swap.meal4.confirm": "Confirm Contribution",
  "swap.meal2.cta": "Get MEAL2 Credits",
  "swap.meal2.confirm": "Confirm Purchase",
  "swap.confirming": "Confirming…",
  "swap.tx.awaitingApproval": "Awaiting wallet approval…",
  "swap.tx.confirmingChain": "Confirming on Solana network…",
  "swap.tx.success": "Success — settlement confirmed on-chain",
  "swap.tx.rejected": "Transaction rejected in your wallet.",
  "swap.tx.insufficient": "Insufficient balance for this transfer.",
  "swap.tx.clusterMismatch": "Your wallet is on a different network. Switch to Solana Mainnet and retry.",
  "swap.tx.walletMissing": "No Solana wallet detected. Connect Phantom or Solflare and retry.",
  "swap.phantomApproving": "Awaiting Phantom approval…",
  "swap.meal2.rateLabel": "Locked rate · 1 USDC = 1 MEAL2",
  "swap.meal2.payWith": "Pay with",
  "swap.meal2.solRoute": "Auto-routed: SOL → USD (Jupiter) → MEAL2 at $1 per unit",
  "swap.meal2.priceFallback": "reference price (feed offline)",
  "swap.rate": "1 USDC ≈ 1 Meal4 · No hidden fees",
  "swap.btn": "Connect & Swap",
  "swap.soon": "Swap powered by Thirdweb · launching soon",
  "swap.meal4.milestoneLabel":
    "Current Milestone: Phase 1 Target — Thailand Sandbox Central Kitchen Infrastructure & Initial Express Expansion",
  "swap.meal4.milestoneProgress": "{raised} / {goal} USDC raised",
  "swap.meal4.percent": "{pct}% funded",
  "swap.meal4.treasuryLabel": "Project treasury wallet",
  "swap.meal4.treasuryNote":
    "Contributions route directly to the SFN project treasury — no DEX, no open-market routing.",
  "swap.meal4.tooltip":
    "Token distribution is backed directly by physical inventory and managed in milestone funding stages to ensure price stability.",
  "swap.meal4.tooltipAria": "How milestone funding works",
  "trust.eyebrow": "Transparency & Trust",
  "trust.title": "Backed by things you can touch.",
  "trust.body":
    "The ecosystem is anchored by physical assets: our SFN Pilot Kitchen in Thailand, supporting real estate, and an operating kitchen serving real plates every day. We share regions and operations openly — exact addresses are protected for the safety of our team and guests.",
  "trust.b1": "Operating restaurant",
  "trust.b2": "Real estate backing",
  "trust.b3": "Audited supply",
  "faq.eyebrow": "FAQ",
  "faq.title": "Frequently Asked Questions",
  "faq.sub":
    "Everything you need to know about the Sustainable Food & Eco Network (SFN) and our meal stabilization ecosystem.",
  "faq.q1": "How can you guarantee a healthy, high-quality meal for $1 despite inflation?",
  "faq.a1":
    "We achieve this by combining three core pillars: strategic bulk-purchasing of raw ingredients directly from local farmers, lowering restaurant operational costs using solar energy infrastructure, and community backing through the MEAL4 inflation shield. This completely disconnects our kitchen's base pricing from volatile market inflation.",
  "faq.q2": "Can one single restaurant handle the demand if the token scales?",
  "faq.a2":
    "No, and it doesn't have to. Our SFN Pilot Kitchen serves as our active real-world proof of concept. The overarching architecture is the SFN (Sustainable Food & Eco Network). As demand grows, independent local kitchens and garkuchens can join the network, accessing our subsidized ingredients and infrastructure to scale the 30 THB meal promise globally.",
  "faq.q3": "How can international supporters participate if they don't live in Thailand?",
  "faq.a3":
    "Global supporters can purchase MEAL2 tokens to initiate digital 'Meal Sponsorships'. These sponsored tokens are transparently allocated to local social aid programs, allowing seniors, low-income families, or vulnerable groups to eat for free or at 30 THB at any certified SFN kitchen.",
  "faq.q4": "What makes MEAL4 different from a standard cryptocurrency?",
  "faq.a4":
    "Unlike speculative tokens, MEAL4 is a practical contract backed by the expansion of real physical food reserves and sustainable gastronomy infrastructure. With its minting authority permanently destroyed, it acts as a mathematically capped store of value designed for food security.",
  "footer.tag":
    "SFN (Sustainable Food & Eco Network) & MealToken24 are dedicated to weaponizing blockchain technology against inflation and global food insecurity. Driven by real kitchens, built for real people.",
  "footer.disclaimer":
    "Disclaimer: MEAL2 and MEAL4 are utility and asset-backed community tokens designed for practical use within the Sustainable Food & Eco Network gastronomy ecosystem. They do not constitute financial investments or traditional securities.",
  "footer.about": "About",
  "footer.contact": "Contact",
  "footer.legal": "Legal",
  "footer.rights": "All rights reserved.",
  "roadmap.eyebrow": "Execution · Trajectory",
  "roadmap.title": "From Factory Floor to Global Protocol",
  "roadmap.sub":
    "A six-stage history of real-world iteration. Every milestone is anchored in operational reality, not a slide deck.",
  "roadmap.card1.q": "2022",
  "roadmap.card1.title": "Factory Worker Food Supply",
  "roadmap.card1.desc":
    "Observing daily food inflation cross 45+ THB per meal, leaving factory workers and low-income communities increasingly priced out of healthy nutrition.",
  "roadmap.card2.q": "2023",
  "roadmap.card2.title": "The $1 Framework Concept",
  "roadmap.card2.desc":
    "Engineered the core economic framework targeting a stable 30 THB margin — the foundation for a permanently affordable, high-quality meal.",
  "roadmap.card3.q": "2024",
  "roadmap.card3.title": "Supply Chain Sourcing Tests",
  "roadmap.card3.desc":
    "Ran direct-from-farmer sourcing pilots and learned the structural limitations of a single-branch model, defining the case for a decentralized regional sourcing hub.",
  "roadmap.card4.q": "2025",
  "roadmap.card4.title": "Multi-Branch Scaling & Solar Roots",
  "roadmap.card4.desc":
    "Expanded into multiple branches and uncovered consistent energy-overhead patterns, validating solar infrastructure as the missing cost-stabilization layer.",
  "roadmap.card5.q": "2026 | Q1",
  "roadmap.card5.title": "Operational Proof & $1 Pilot",
  "roadmap.card5.desc":
    "Achieved absolute sales stability throughout the full month — no mid-month drops — proving the 30 THB meal model is operationally sustainable at scale.",
  "roadmap.card6.q": "2026 | Mid-May+",
  "roadmap.card6.title": "SFN Tokenization & SolarPando Sprint",
  "roadmap.card6.desc":
    "Official launch of SFN on Solana: MEAL4 and MEAL2 token genesis, immutability verification, and the SolarPando infrastructure sprint go live.",

  "docs.eyebrow": "Knowledge Base",
  "docs.title": "White Paper & Legal Documents",
  "docs.sub": "Download the official SFN documentation and audit reports.",
  "credits.line": "Concept & Framework created by Boy Khomkrit — Initial Release: July 04, 2021",
  "credits.date": "Original Creation Date: July 04, 2021 (04.07.2021)",
  "credits.version": "Whitepaper v1.0 — Original Release: July 04, 2021",
  "docs.btn1": "SFN Ecosystem Whitepaper (EN)",
  "docs.btn2": "Executive Tokenomics Summary (DE)",
  "docs.btn3": "Thailand Gastronomy Legal Framework",
  "docs.btn4": "Cryptographic Security Audit Report",
  "vp.eyebrow": "VillagePando · Ecosystem Gateway",
  "vp.title": "One network, layered modules.",
  "vp.sub":
    "MEAL24 is the live anchor. SolarPando, PlantyPando and AquaPando connect into the same on-chain backbone — each module activates independently when its real-world infrastructure is verified.",
  "vp.dependency": "Real-world dependency",
  "vp.locked": "Ecosystem Phase 2 · Verification Pending",
  "vp.earlyAccess": "Early Access",
  "vp.cta": "Open early-access whitelist",
  "vp.solar.desc":
    "Off-grid solar microgrids deployed at partner kitchens. Cuts cooking-fuel volatility out of the meal price.",
  "vp.solar.dependency":
    "Supplies off-grid solar energy directly to live MEAL24 Pilot Kitchens.",
  "vp.planty.desc":
    "Regional farm cooperatives tokenizing forward contracts for rice, oil and produce — the upstream side of MEAL4 stability.",
  "vp.planty.dependency":
    "Locks in farm-gate ingredient prices that feed the MEAL2 daily kitchen flow.",
  "vp.aqua.desc":
    "Filtered-water and beverage micro-stations co-located with kitchens. Removes bottled-water markup for staff and guests.",
  "vp.aqua.dependency":
    "Co-located with MEAL24 kitchens; ensures clean water at the 30 THB meal anchor point.",
  "vp.modal.close": "Close",
  "vp.modal.title": "Join {module} Early Access",
  "vp.modal.body":
    "Drop your contact and we'll reach out when this module's whitelist opens. No spam, no token sale promises.",
  "vp.modal.email": "Email",
  "vp.modal.wallet": "Solana wallet (optional)",
  "vp.modal.note": "Note (optional)",
  "vp.modal.notePlaceholder": "Tell us how you'd contribute — operator, partner, supporter…",
  "vp.modal.submit": "Request Early Access",
  "vp.modal.submitting": "Submitting…",
  "vp.modal.privacy":
    "Stored in our secure contact database. Used only for VillagePando launch updates.",
  "vp.modal.success.title": "You're on the list.",
  "vp.modal.success.body":
    "We'll reach out as soon as this module clears verification and opens its whitelist.",
  "nav.villagepando": "VillagePando",
  "nav.connectWallet": "Connect Wallet",
  "swap.connectWallet": "Connect Wallet to Swap",
  "swap.jupiter": "Jupiter Terminal integration · placeholder",
  "verify.meal4.title": "MEAL4 — Inflation Shield Verification",
  "verify.meal4.sub": "Immutable asset parameters",
  "verify.meal2.title": "MEAL2 — Daily Utility Verification",
  "verify.meal2.sub": "Flexible utility parameters",
  "verify.freeze": "Freeze Authority: REVOKED",
  "verify.mint.destroyed": "Mint Authority: DESTROYED",
  "verify.mint.retained": "Mint Authority: RETAINED FOR NETWORK GROWTH",
  "verify.meal4.cta": "View MEAL4 on Solana Explorer",
  "verify.meal2.cta": "View MEAL2 on Solana Explorer",
  "verify.meal4.download": "Download MEAL4 Metadata JSON",
  "verify.meal2.download": "Download MEAL2 Metadata JSON",
  "barometer.eyebrow": "Live · On-Chain · Verified",
  "barometer.title.a": "Real-World",
  "barometer.title.b": "Inventory Barometer",
  "barometer.sub":
    "A transparent window into the physical reserves powering every meal. Numbers update from our pilot kitchen — no speculation, just stock.",
  "barometer.rice": "Rice Reserves",
  "barometer.rice.note": "12-week buffer",
  "barometer.oil": "Vegetable Oil",
  "barometer.oil.note": "Sourced via co-op",
  "barometer.solar": "Solar Power Status",
  "barometer.live": "Live",
  "barometer.active": "Active",
  "barometer.syncNote":
    "Note: All MEAL2 transactions at the counter directly sync with our real-time Inventory Barometer.",
  "tokeno.eyebrow": "// Tokenomics · Dual-Token Architecture",
  "tokeno.title": "SFN Resource Distribution & Sustainability",
  "tokeno.sub":
    "Two complementary tokens, one stabilization engine. MEAL4 freezes the price of food with capped, asset-backed reserves; MEAL2 circulates that value into every plate, loyalty reward, and sponsored meal across the network.",
  "tokeno.toggleAria": "Token distribution",
  "tokeno.meal4.tagline": "Capped Supply · Asset-Backed Store of Value",
  "tokeno.meal4.supply": "1,000,000 MEAL4 · Hard Cap",
  "tokeno.meal4.distTitle": "MEAL4 Distribution",
  "tokeno.meal2.tagline": "Velocity Layer · Loyalty · Sponsorships",
  "tokeno.meal2.supply": "Network Utility · Elastic Supply",
  "tokeno.meal2.distTitle": "MEAL2 Distribution",
  "tokeno.centerAlloc": "SFN · ALLOCATION",
  "tokeno.interactEyebrow": "// How the two flows interact",
  "tokeno.interact.meal4": "MEAL4 reserves",
  "tokeno.interact.meal2": "MEAL2 circulates",
  "tokeno.interactBody":
    "back the network with capped, audited collateral — locking ingredient costs and stabilizing the 30 THB meal anchor.",
  "tokeno.interactBody2":
    "that locked-in value into daily payments, loyalty, and sponsored meals. Every MEAL2 transaction at the counter draws against a price already frozen by MEAL4 — that is how an investor reads our sustainability model in one glance.",
  "tokeno.sr.chartSummary":
    "Donut chart showing allocation across four segments. Use the left and right arrow keys to move between segments.",
  "tokeno.sr.chartHint": "Each segment is clickable to open its detail view.",
  "tokeno.sr.legendAria":
    "Distribution segments — use arrow keys to navigate, Enter or Space to open details.",
  "tokeno.sr.segment": "{label}: {value} percent of allocation.",
  "tokeno.sr.segmentHint": "Click or press Enter to open detail view.",
  "tokeno.sr.activated": "Selected {label}, {value} percent of allocation.",
  "tokeno.loading": "Loading distribution…",
  "tokeno.modal.toneSuffix": " · metric",
  "tokeno.modal.detailView": "detail view",
  "tokeno.modal.verified": "verified",
  "tokeno.modal.closeAria": "Close {label} details",
  "tokeno.modal.valueAria": "Value: {value}",
  "tokeno.preview.eyebrow": "// Live Preview",
  "tokeno.preview.default":
    "💡 Select a segment or a tokenomics target to explore in-depth on-chain metrics and liquidity backing.",
  "tokeno.preview.activeEyebrow": "// Selected Allocation",
  "tokeno.preview.cta": "Open detailed breakdown",
  "tokeno.preview.allocation": "Allocation",
  "tokeno.preview.openAria": "Open detail view for {label}",

  "tokeno.m4-stability.label": "Stability Reserves & Liquidity Backing",
  "tokeno.m4-stability.desc":
    "Protocol-owned liquidity that anchors MEAL4 against USDC and absorbs price shocks.",
  "tokeno.m4-stability.expl":
    "Forty percent of the capped 1,000,000 MEAL4 supply backs deep, protocol-owned liquidity. This pool absorbs volatility, guarantees redemption at the 30 THB meal anchor, and ensures every token holder retains real purchasing power — regardless of market conditions.",
  "tokeno.m4-stability.s1l": "Liquidity Backing",
  "tokeno.m4-stability.s1v": "Protocol-owned",
  "tokeno.m4-stability.s2l": "Primary Pair",
  "tokeno.m4-stability.s2v": "MEAL4 / USDC",
  "tokeno.m4-stability.s3l": "Meal Anchor",
  "tokeno.m4-stability.s3v": "30 THB / meal",
  "tokeno.m4-stability.s4l": "Reserve Ratio",
  "tokeno.m4-stability.s4v": "1 : 1.4",

  "tokeno.m4-collateral.label": "Real Asset Collateral (Kitchens & Land)",
  "tokeno.m4-collateral.desc":
    "Backed 1:1 by operating restaurants, real estate, and certified kitchen infrastructure.",
  "tokeno.m4-collateral.expl":
    "Thirty percent of MEAL4 is collateralized by tangible assets: the anchor kitchen in the Thailand Sandbox, supporting real estate parcels, and certified kitchen infrastructure across the SFN network. These reserves give MEAL4 its inflation-shield property — value you can walk into.",
  "tokeno.m4-collateral.s1l": "Anchor Kitchens",
  "tokeno.m4-collateral.s1v": "1 + 6 expansion",
  "tokeno.m4-collateral.s2l": "Asset Audits",
  "tokeno.m4-collateral.s2v": "Quarterly",
  "tokeno.m4-collateral.s3l": "Insurance Coverage",
  "tokeno.m4-collateral.s3v": "100%",
  "tokeno.m4-collateral.s4l": "Region",
  "tokeno.m4-collateral.s4v": "Thailand Sandbox",

  "tokeno.m4-procurement.label": "Bulk Procurement Treasury",
  "tokeno.m4-procurement.desc":
    "Locks ingredient costs below market inflation via direct multi-year farmer contracts.",
  "tokeno.m4-procurement.expl":
    "Twenty percent funds the strategic procurement treasury — multi-year forward contracts with rice cooperatives, oil producers, and produce farms. By committing capital upstream, MEAL4 freezes input prices at the source, decoupling our kitchens from market inflation.",
  "tokeno.m4-procurement.s1l": "Forward Contracts",
  "tokeno.m4-procurement.s1v": "12 active",
  "tokeno.m4-procurement.s2l": "Rice Buffer",
  "tokeno.m4-procurement.s2v": "12 weeks",
  "tokeno.m4-procurement.s3l": "Oil Buffer",
  "tokeno.m4-procurement.s3v": "8 weeks",
  "tokeno.m4-procurement.s4l": "Cost Lock Avg.",
  "tokeno.m4-procurement.s4v": "−18% vs. spot",

  "tokeno.m4-safety.label": "Audits, Compliance & Emergency Reserve",
  "tokeno.m4-safety.desc":
    "Smart-contract audits, regulatory compliance, and a crisis-response reserve.",
  "tokeno.m4-safety.expl":
    "A disciplined ten percent funds the operational foundation: recurring smart-contract audits, multi-jurisdiction regulatory compliance, and a sealed emergency reserve activated only in case of supply-chain shock or natural disaster.",
  "tokeno.m4-safety.s1l": "Audits Completed",
  "tokeno.m4-safety.s1v": "3",
  "tokeno.m4-safety.s2l": "Emergency Reserve",
  "tokeno.m4-safety.s2v": "$120K",
  "tokeno.m4-safety.s3l": "Compliance Regions",
  "tokeno.m4-safety.s3v": "2",
  "tokeno.m4-safety.s4l": "Response SLA",
  "tokeno.m4-safety.s4v": "<24 h",

  "tokeno.m2-operations.label": "Daily Operations & Merchant Float",
  "tokeno.m2-operations.desc":
    "Working capital that keeps MEAL2 liquid at every counter, terminal, and partner kitchen.",
  "tokeno.m2-operations.expl":
    "Forty-five percent of MEAL2 circulates as the daily merchant float — instant settlement at the counter, sub-second QR payments, and frictionless top-ups. This is the velocity layer of the SFN: it keeps every plate paid for in real time.",
  "tokeno.m2-operations.s1l": "Avg. Settlement",
  "tokeno.m2-operations.s1v": "0.4 s",
  "tokeno.m2-operations.s2l": "Daily Throughput",
  "tokeno.m2-operations.s2v": "8,400+ meals",
  "tokeno.m2-operations.s3l": "Active Terminals",
  "tokeno.m2-operations.s3v": "42",
  "tokeno.m2-operations.s4l": "Fees",
  "tokeno.m2-operations.s4v": "0%",

  "tokeno.m2-loyalty.label": "Loyalty Rewards & Cashback",
  "tokeno.m2-loyalty.desc":
    "Cashback for returning guests and merchant loyalty pools that compound network usage.",
  "tokeno.m2-loyalty.expl":
    "Twenty-five percent fuels the loyalty layer: automatic cashback for returning diners, merchant rebate pools, and tier-based discounts that compound the more a guest engages. MEAL2 transforms every transaction into a relationship.",
  "tokeno.m2-loyalty.s1l": "Avg. Cashback",
  "tokeno.m2-loyalty.s1v": "12%",
  "tokeno.m2-loyalty.s2l": "Loyalty Tiers",
  "tokeno.m2-loyalty.s2v": "4",
  "tokeno.m2-loyalty.s3l": "Repeat Rate",
  "tokeno.m2-loyalty.s3v": "63%",
  "tokeno.m2-loyalty.s4l": "Reward Cycle",
  "tokeno.m2-loyalty.s4v": "Weekly",

  "tokeno.m2-social.label": "Social Aid & Sponsored Meals",
  "tokeno.m2-social.desc":
    "Digital meal sponsorships routed transparently to vulnerable families and seniors.",
  "tokeno.m2-social.expl":
    "Twenty percent of MEAL2 powers the social-aid engine. International supporters sponsor meals digitally; tokens are routed on-chain to verified recipients — seniors, low-income families, and crisis-response cohorts — redeemable at any certified SFN kitchen.",
  "tokeno.m2-social.s1l": "Sponsored Meals / mo",
  "tokeno.m2-social.s1v": "8,400+",
  "tokeno.m2-social.s2l": "Active Recipients",
  "tokeno.m2-social.s2v": "14,200",
  "tokeno.m2-social.s3l": "Sponsor Countries",
  "tokeno.m2-social.s3v": "9",
  "tokeno.m2-social.s4l": "On-Chain Proof",
  "tokeno.m2-social.s4v": "100%",

  "tokeno.m2-growth.label": "Ecosystem Rewards & Network Growth",
  "tokeno.m2-growth.desc":
    "Onboarding incentives for new partner kitchens, farmers, and community validators.",
  "tokeno.m2-growth.expl":
    "Ten percent is reserved for ecosystem growth: onboarding grants for new partner kitchens, performance bonuses for sourcing farmers, and community validator rewards. This is how the Sustainable Food & Eco Network compounds beyond the anchor kitchen.",
  "tokeno.m2-growth.s1l": "Kitchen Partners",
  "tokeno.m2-growth.s1v": "42",
  "tokeno.m2-growth.s2l": "Onboarding Grant",
  "tokeno.m2-growth.s2v": "Up to 5K MEAL2",
  "tokeno.m2-growth.s3l": "Validators",
  "tokeno.m2-growth.s3v": "Community-run",
  "tokeno.m2-growth.s4l": "Growth Target '26",
  "tokeno.m2-growth.s4v": "+120 sites",

  "swap2.eyebrow": "// Acquisition · Two Purposes",
  "swap2.title": "Choose How You Participate",
  "swap2.sub":
    "MEAL4 secures the infrastructure. MEAL2 feeds the daily network. Each token is acquired differently — by design.",
  "tokenart.meal4": "MEAL4: Governance & Infrastructure Growth — 100M Treasury",
  "tokenart.meal2": "MEAL2: $1 Utility & Meal Voucher — Price-Protected",
  "tokenart.grouplabel": "Token highlights",
  "tokenart.highlighted": "{token} coin highlighted",

  "meal4.badge": "Asset-Backed Shield",
  "meal4.title": "MEAL4 Token Sale",
  "meal4.subtitle": "Secure the Infrastructure Contract",
  "meal4.price": "Price",
  "meal4.priceValue": "Fixed Reference Value",
  "meal4.hardCap": "Hard Cap",
  "meal4.neverInflated": "· Never Inflated",
  "meal4.desc":
    "Acquiring MEAL4 directly funds our physical food reserves and solar grid infrastructure. It locks long-term value into the ecosystem to suppress core cooking costs.",
  "meal2.badge": "Daily Utility & Aid",
  "meal2.title": "MEAL2 Distribution",
  "meal2.subtitle": "Get Daily Meal Credits",
  "meal2.tab.cash": "At The Cashier",
  "meal2.web3desc":
    "Swap USDC or SOL directly for MEAL2 to use for instant smartphone payments or to initiate international meal sponsorships.",
  "meal2.cashdesc":
    "No crypto wallet needed for daily guests. Purchase MEAL2 digital credits directly at the SFN Pilot Kitchen counter using Thai Baht (THB) or Credit Card.",
  "meal2.viewGuide": "View Local Redemption Guide",
  "redemption.eyebrow": "Local Redemption",
  "redemption.title": "How to Use MEAL2 at the Restaurant Counter",
  "redemption.sub":
    "Three simple steps to enjoy high-quality, inflation-proof meals using traditional currency.",
  "canvas.simActive": "SIM · ACTIVE",
  "canvas.bulkSourcing": "BULK · SOURCING",
  "canvas.networkScaling": "NETWORK · SCALING",
  "canvas.mealSponsor": "MEAL · SPONSOR",
  "canvas.realContract": "REAL · CONTRACT",
  "transparency.eyebrow": "// Web3 · Trust · Verification",
  "transparency.h.a": "On-Chain ",
  "transparency.h.b": "Transparency",
  "transparency.h.c": " & Verification",
  "transparency.sub":
    "The Sustainable Food & Eco Network operates with absolute openness. Verify our smart contracts, immutable metadata, and token parameters live on the Solana blockchain.",
  "transparency.jsonStructure": "Solana Metadata JSON Structure",
  "transparency.jsonImmutable": "// Immutable. Cannot be altered.",
  "transparency.jsonCeiling": "// Hard-coded ceiling.",
  "verify.scanTitle": "Smart Contract Security Scan",
  "verify.mainnetRealtime": "Solana Mainnet · Real-time",
  "verify.connecting": "Connecting to Solana Mainnet RPC...",
  "verify.cryptoSecured": "Cryptographically secured and verified via Solana Mainnet RPC.",
  "verify.genesisSnapshot": "Displayed via verified genesis snapshot",
  "verify.retryScan": "Retry Blockchain Scan",
  "verify.privacyLabel": "Privacy Notice:",
  "verify.privacyText":
    "To protect community security, this platform operates strictly on a contract-level basis. SFN never tracks, queries, or publicly displays individual wallet addresses, administrator keys, or holder balances.",
  "verify.item.meal4Supply.label": "MEAL4 Supply Cap Verified",
  "verify.item.meal4Supply.statusPassed": "PASSED - Capped at 1,000,000",
  "verify.item.meal4Supply.statusLive": "PASSED - On-Chain Supply: ",
  "verify.item.meal4Mint.label": "MEAL4 Mint Authority",
  "verify.item.meal4Mint.statusPassed": "PASSED - Destroyed (1M Supply Hardcapped)",
  "verify.item.meal4Mint.statusActive": "ACTIVE - Mint Authority Present",
  "verify.item.meal4Freeze.label": "MEAL4 Freeze Authority",
  "verify.item.meal4Freeze.statusPassed": "PASSED - Revoked (No Central Control)",
  "verify.item.meal4Freeze.statusActive": "ACTIVE - Freeze Authority Present",
  "verify.item.meal2Freeze.label": "MEAL2 Freeze Authority",
  "verify.item.meal2Freeze.statusPassed": "PASSED - Revoked (Liquidity Unlocked)",
  "verify.item.meal2Freeze.statusActive": "ACTIVE - Freeze Authority Present",
  "verify.item.meal2Mint.label": "MEAL2 Mint Authority",
  "verify.item.meal2Mint.statusRevoked": "REVOKED - Supply Frozen",
  "verify.item.meal2Mint.statusActive": "ACTIVE - Managed by SFN Growth Protocol",
  "verify.item.meal2Supply.label": "MEAL2 Circulating Supply",
  "verify.item.meal2Supply.statusLive": "LIVE - ",
  "verify.badge.connecting": "Connecting",
  "verify.badge.cached": "Cached",
  "verify.badge.verified": "Verified",
  "verify.networkBusy": "Network busy, retrying connection... (attempt ",
  "connection.eyebrow": "// The Connection",
  "connection.title": "From Digital Token to Physical Plate",
  "connection.sub": "Three deliberate steps convert on-chain value into a meal you can hold.",
  "connection.step1.title": "Bulk Purchasing",
  "connection.step1.text": "MEAL4 reserves fund direct, large-volume sourcing from local farmers — locking ingredient costs below market inflation.",
  "connection.step2.title": "Solar Infrastructure",
  "connection.step2.text": "Off-grid solar arrays power partner kitchens 24/7, eliminating energy volatility from the cost of every plate.",
  "connection.step3.title": "Redeemable Meals",
  "connection.step3.text": "Guests scan, pay in MEAL2, and receive a hot, nutritious plate for under $1 — a digital contract resolved on a real table.",
  "footer.marquee": "MEAL ECOSYSTEM · MEAL ECOSYSTEM · MEAL ECOSYSTEM",
  "jupiter.eyebrow": "// Web3 · Liquidity · Access",
  "jupiter.h.a": "Acquire MEAL via ",
  "jupiter.h.b": "Jupiter",
  "jupiter.desc":
    "Trade USDC, SOL, or any SPL token for MEAL2 and MEAL4 directly inside our embedded Jupiter Terminal — the deepest liquidity router on Solana. Operators of partner kitchens get their own dedicated dashboard.",
  "jupiter.partnerLogin": "Partner Portal Login",
  "jupiter.partnerNote": "For verified kitchen operators & supply partners only.",
  "jupiter.youReceive": "You Receive",
  "vp.meta.title": "VillagePando — Ecosystem Governance Dashboard",
  "vp.meta.description": "Master governance hub for the VillagePando real-world asset network: MEAL24, SolarPando, PlantyPando and AquaPando — unified TAVL, cross-token flow, and portal access.",
  "vp.meta.ogTitle": "VillagePando — Ecosystem Governance Dashboard",
  "vp.meta.ogDescription": "TAVL, physical anchor map, and inter-token flow across the VillagePando real-world asset ecosystem.",
  "vp.header.subtitle": "Governance Dashboard",
  "vp.nav.monitor": "Monitor",
  "vp.nav.map": "Map",
  "vp.nav.flow": "Flow",
  "vp.nav.portals": "Portals",
  "vp.header.mealSiteLink": "MEAL24 site",
  "vp.footer.tagline": "VillagePando · macro governance hub",
  "vp.footer.networkPrefix": "Solana mainnet ·",
  "vp.modules.meal24.tagline": "Live · Inflation-shielded meal anchor",
  "vp.modules.solar.tagline": "Energy layer · Off-grid microgrids",
  "vp.modules.planty.tagline": "Agriculture layer · Tokenized forwards",
  "vp.modules.aqua.tagline": "Hydration layer · Filtered-water hubs",
  "vp.hero.eyebrow": "// VillagePando · Master Network",
  "vp.hero.titleLine1": "One ecosystem.",
  "vp.hero.titleLine2": "Four real-world layers.",
  "vp.hero.body": "VillagePando is the governance parent that holds MEAL24 (food), SolarPando (energy), PlantyPando (agriculture) and AquaPando (water) under a single on-chain backbone. Each module activates independently — but reports up here.",
  "vp.macro.eyebrow": "// Macro Monitor",
  "vp.macro.title": "Aggregate ecosystem health",
  "vp.macro.sub": "Roll-up across MEAL24 (live) and the verification-pending sub-modules. Figures reflect on-chain state and verified physical inventory.",
  "vp.macro.stat.tavl.label": "Total Aggregate Value Locked",
  "vp.macro.stat.tavl.delta": "+4.2% / 30d",
  "vp.macro.stat.anchors.label": "Active Physical Anchors",
  "vp.macro.stat.anchors.sub": "Thailand Sandbox corridor",
  "vp.macro.stat.meals.label": "Meals Backed (MEAL24)",
  "vp.macro.stat.meals.sub": "30 THB anchor maintained",
  "vp.macro.stat.submodules.label": "Sub-modules Online",
  "vp.macro.stat.submodules.sub": "3 in verification",
  "vp.map.eyebrow": "// Physical Network",
  "vp.map.title": "Thailand anchor map",
  "vp.map.sub": "Live operational nodes powering the MEAL24 meal anchor — extended progressively across the southern corridor.",
  "vp.map.canvasEyebrow": "// Thailand · Live Network",
  "vp.map.canvasTitle": "Thailand Sandbox corridor active",
  "vp.map.ariaLabel": "Stylized map of Thailand showing VillagePando anchor nodes",
  "vp.map.legend.active": "Active",
  "vp.map.legend.pilot": "Pilot",
  "vp.map.legend.planned": "Planned",
  "vp.map.rosterEyebrow": "// Anchor Roster",
  "vp.map.rosterTitle": "Operational nodes",
  "vp.map.status.active": "active",
  "vp.map.status.pilot": "pilot",
  "vp.map.status.planned": "planned",
  "vp.flow.eyebrow": "// Cross-Token Flow",
  "vp.flow.title": "Inter-token value cycle",
  "vp.flow.sub": "How Solana-native sub-tokens cycle physical value: energy → kitchen → ingredients → water → meal token.",
  "vp.flowGraph.eyebrow": "// Unified Solana Layer · particle flow",
  "vp.flowGraph.ariaLabel": "Inter-token flow graph",
  "vp.flowGraph.caption": "Glowing trails represent token-routed value across the same Solana layer.",
  "vp.flowGraph.node.solar.sublabel": "Energy",
  "vp.flowGraph.node.meal24.sublabel": "Kitchen anchor",
  "vp.flowGraph.node.planty.sublabel": "Ingredients",
  "vp.flowGraph.node.aqua.sublabel": "Water",
  "vp.flowGraph.edge.solarToMeal": "kWh → kitchen",
  "vp.flowGraph.edge.plantyToMeal": "ingredients → menu",
  "vp.flowGraph.edge.aquaToMeal": "filtered water → service",
  "vp.flowGraph.edge.mealToPlanty": "MEAL24 → farmgate revenue",
  "vp.portals.eyebrow": "// Cross-Utility Portals",
  "vp.portals.title": "Sub-module entryways",
  "vp.portals.sub": "MEAL24 is live. Adjacent modules open whitelists sequentially as their physical infrastructure clears verification.",
  "vp.portalCard.badge.live": "Live",
  "vp.portalCard.badge.phase2": "Phase 2",
  "vp.portalCard.openPortal": "Open portal",
  "vp.portalCard.contributePrefix": "Contribute · mint",
  "vp.portalCard.joinWhitelist": "Join whitelist",
  "vp.whitelistModal.badge": "Phase 2 · whitelist",
  "vp.whitelistModal.titlePrefix": "Join",
  "vp.whitelistModal.titleSuffix": "early access",
  "vp.whitelistModal.body": "Drop your contact and we'll reach out when this module's whitelist opens.",
  "vp.whitelistModal.closeAria": "Close",
  "vp.whitelistModal.successTitle": "You're on the list.",
  "vp.whitelistModal.successBody": "We'll reach out as soon as this module opens its whitelist.",
  "vp.whitelistModal.fields.email": "Email",
  "vp.whitelistModal.fields.emailPlaceholder": "you@domain.com",
  "vp.whitelistModal.fields.wallet": "Solana wallet (optional)",
  "vp.whitelistModal.fields.walletPlaceholder": "Solana address",
  "vp.whitelistModal.submitting": "Submitting…",
  "vp.whitelistModal.submit": "Request early access",
  "vp.whitelistModal.disclaimer": "Stored in our secure contact database. Used only for VillagePando launch updates.",
  "vp.nexus.eyebrow": "// Pando Ecosystem · Interactive Cockpit",
  "vp.nexus.title": "Circular value flow across the network.",
  "vp.nexus.sub": "Every asset supplies the others. Tap a node to see how it reduces cost and drives profit for the rest of the ecosystem.",
  "vp.nexus.wheelAriaLabel": "Pando ecosystem wheel",
  "vp.nexus.svgTitle": "PANDO NEXUS",
  "vp.nexus.svgSubtitle": "COCKPIT",
  "vp.nexus.activateAria": "Activate",
  "vp.nexus.flowsIntoLabel": "Flows into",
  "vp.nexus.sfn.tagline": "Central Kitchen · Meal anchor",
  "vp.nexus.sfn.headline": "SFN is the demand engine of the network.",
  "vp.nexus.sfn.body": "Every meal produced in the Central Kitchen consumes water, ingredients and energy at contracted internal rates — turning the other Pando assets into recurring, revenue-generating utilities instead of speculative infrastructure.",
  "vp.nexus.sfn.b1.label": "Guaranteed offtake",
  "vp.nexus.sfn.b1.value": "~1,200 meals/day at pilot capacity",
  "vp.nexus.sfn.b2.label": "Internal contract rate",
  "vp.nexus.sfn.b2.value": "−22% vs. local wholesale",
  "vp.nexus.sfn.b3.label": "Feeds",
  "vp.nexus.sfn.b3.value": "PlantyPando · AquaPando · VillagePando",
  "vp.nexus.planty.tagline": "Perennial ingredient supply",
  "vp.nexus.planty.headline": "PlantyPando de-risks the food supply chain.",
  "vp.nexus.planty.body": "Long-lease reforested land supplies SFN with tokenized ingredient forwards at fixed prices, insulating the Central Kitchen from spot-market volatility and simultaneously appreciating land value for VillagePando residents.",
  "vp.nexus.planty.b1.label": "Ingredient hedge",
  "vp.nexus.planty.b1.value": "Fixed 25y forward pricing",
  "vp.nexus.planty.b2.label": "Land appreciation",
  "vp.nexus.planty.b2.value": "Compounds under VillagePando",
  "vp.nexus.planty.b3.label": "Supplies",
  "vp.nexus.planty.b3.value": "SFN kitchens · Village residents",
  "vp.nexus.aqua.tagline": "Filtered-water hubs",
  "vp.nexus.aqua.headline": "AquaPando guarantees production continuity.",
  "vp.nexus.aqua.body": "UV-filtered reservoirs remove dry-season risk for the Central Kitchen, irrigate PlantyPando parcels, and pipe premium AquaP water to Village residents — a single asset monetized three ways.",
  "vp.nexus.aqua.b1.label": "Reservoir capacity",
  "vp.nexus.aqua.b1.value": "20,000 L per hub",
  "vp.nexus.aqua.b2.label": "Revenue streams",
  "vp.nexus.aqua.b2.value": "3 (kitchen · irrigation · retail)",
  "vp.nexus.aqua.b3.label": "Supplies",
  "vp.nexus.aqua.b3.value": "SFN · Village · Planty",
  "vp.nexus.solar.tagline": "Zero-cost energy layer",
  "vp.nexus.solar.headline": "SolarPando collapses the operating cost curve.",
  "vp.nexus.solar.body": "Off-grid microgrids power the Central Kitchen, pump AquaPando reservoirs and light every VillagePando block at zero marginal energy cost — turning the largest OPEX line item across the network into a shared, tokenized asset.",
  "vp.nexus.solar.b1.label": "Peak generation",
  "vp.nexus.solar.b1.value": "12 kWp per anchor site",
  "vp.nexus.solar.b2.label": "OPEX offset",
  "vp.nexus.solar.b2.value": "≈100% of kitchen energy",
  "vp.nexus.solar.b3.label": "Powers",
  "vp.nexus.solar.b3.value": "SFN · Village · Aqua pumps",
  "vp.nexus.village.tagline": "Demand + governance layer",
  "vp.nexus.village.headline": "VillagePando closes the loop.",
  "vp.nexus.village.body": "Residential blocks are the end-consumer of every other asset — meals from SFN, energy from Solar, water from Aqua, land from Planty — routing recurring household spend back into the same tokens residents already hold as governance.",
  "vp.nexus.village.b1.label": "Household demand",
  "vp.nexus.village.b1.value": "Recurring, non-speculative",
  "vp.nexus.village.b2.label": "Governance",
  "vp.nexus.village.b2.value": "1 block = 1 vote weight",
  "vp.nexus.village.b3.label": "Consumes",
  "vp.nexus.village.b3.value": "All four upstream assets",
  "vp.rwa.eyebrow": "// Live RWA Terminal",
  "vp.rwa.title": "Physical assets, on-chain telemetry",
  "vp.rwa.sub": "Every card below is a real-world resource on Thai soil, streamed into the ecosystem treasury and mirrored by circulating token supply.",
  "vp.rwa.viewToggleAria": "Data view mode",
  "vp.rwa.toggle.physical": "Physical",
  "vp.rwa.toggle.financial": "Financial",
  "vp.rwa.strip.tavl.label": "TAVL (live)",
  "vp.rwa.strip.tavl.physicalValue": "5 verified layers",
  "vp.rwa.strip.chain.label": "Chain",
  "vp.rwa.strip.chain.value": "Solana Mainnet",
  "vp.rwa.strip.latency.label": "Oracle latency",
  "vp.rwa.strip.latency.value": "1.2s",
  "vp.rwa.strip.uptime.label": "Anchor uptime",
  "vp.rwa.strip.uptime.value": "99.98%",
  "vp.rwa.connect.connecting": "Connecting…",
  "vp.rwa.connect.cta": "Connect Wallet",
  "vp.rwa.livePulse": "Live · streaming",
  "vp.rwa.metricCard.online": "Online",
  "vp.rwa.bridge.eyebrow": "// Token Utility Bridge",
  "vp.rwa.bridge.title": "MEAL2, MEAL4 and Pando move real assets on Thai soil.",
  "vp.rwa.bridge.body": "Every unit minted is collateralized by verified kitchen throughput, kilowatt-hours, liters distributed, and square meters of land. Redemption is physical — not synthetic.",
  "vp.rwa.bridge.role.meal2": "Utility credit",
  "vp.rwa.bridge.role.meal4": "Meal anchor",
  "vp.rwa.bridge.role.pando": "Governance",
  "vp.rwa.investor.eyebrow": "// Investor Profile · Simulated",
  "vp.rwa.investor.walletLabel": "Wallet",
  "vp.rwa.investor.portfolioLabel": "Portfolio value ·",
  "vp.rwa.investor.disclaimer": "Read-only preview · no live keys touched",
  "vp.rwa.metric.meal24.title": "MEAL24 Ecosystem Velocity",
  "vp.rwa.metric.meal24.subtitle": "SFN Central Kitchen throughput · rolling 30d",
  "vp.rwa.metric.meal24.unit": "kg Moo Krob produced",
  "vp.rwa.metric.meal24.deltaPhysical": "+8.4% w/w",
  "vp.rwa.metric.meal24.deltaFinancial": "+6.1% w/w",
  "vp.rwa.metric.meal24.detail": "Physical meals processed by the anchor kitchen, feeding MEAL24 burn.",
  "vp.rwa.metric.solar.title": "SolarPando Grid Output",
  "vp.rwa.metric.solar.subtitle": "Off-grid microgrid + EV charging · 24h",
  "vp.rwa.metric.solar.unit": "kWh · 37 active EV sessions",
  "vp.rwa.metric.solar.deltaPhysical": "+3.2% d/d",
  "vp.rwa.metric.solar.deltaFinancial": "+2.9% d/d",
  "vp.rwa.metric.solar.detail": "Clean generation delivered to kitchens, water treatment, and EV bays.",
  "vp.rwa.metric.aqua.title": "AquaPando Reserves",
  "vp.rwa.metric.aqua.subtitle": "UV-filtered distribution + reservoir level",
  "vp.rwa.metric.aqua.unit": "distributed · reservoir 82%",
  "vp.rwa.metric.aqua.deltaPhysical": "+1.7% d/d",
  "vp.rwa.metric.aqua.deltaFinancial": "+1.4% d/d",
  "vp.rwa.metric.aqua.detail": "Premium AquaP water bottled and piped to kitchen + community offtake.",
  "vp.rwa.metric.planty.title": "PlantyPando Token Backing",
  "vp.rwa.metric.planty.subtitle": "Secured land + reforestation collateral",
  "vp.rwa.metric.planty.unit": "long-lease · 1,624 trees geo-tagged",
  "vp.rwa.metric.planty.deltaPhysical": "+4.8% m/m",
  "vp.rwa.metric.planty.deltaFinancial": "+3.6% m/m",
  "vp.rwa.metric.planty.detail": "Physical land + biomass permanently backing PLANTY circulation.",
  "vp.rwa.metric.village.title": "VillagePando Occupancy",
  "vp.rwa.metric.village.subtitle": "Smart housing sustained by the loop",
  "vp.rwa.metric.village.unit": "units live · food+water+solar",
  "vp.rwa.metric.village.deltaPhysical": "+2 units w/w",
  "vp.rwa.metric.village.deltaFinancial": "+5.0% w/w",
  "vp.rwa.metric.village.detail": "Housing units fully covered by ecosystem-generated resources.",
  "vp.rwa.wallet.token.meal2.name": "Daily Utility Credit",
  "vp.rwa.wallet.token.meal4.name": "Meal Anchor",
  "vp.rwa.wallet.token.pando.name": "Governance",
  "vp.rwa.wallet.token.solar.name": "SolarPando",
  "vp.rwa.wallet.token.planty.name": "PlantyPando",
  "vp.rwa.wallet.token.aqua.name": "AquaPando",
  "vp.swap.eyebrow": "// Internal DEX · Pando Router",
  "vp.swap.title": "Ecosystem token swap",
  "vp.swap.sub": "Route liquidity between MEAL, Solar, Aqua, Planty and Village layers through the Pando internal AMM — a stability channel for the real-world backed ecosystem.",
  "vp.swap.smartRouterLabel": "Pando Smart Router",
  "vp.swap.settingsAria": "Swap settings",
  "vp.swap.slippageButton": "0.5% slippage",
  "vp.swap.panel.from": "From",
  "vp.swap.panel.to": "To (estimated)",
  "vp.swap.flipAria": "Flip swap direction",
  "vp.swap.panel.balancePrefix": "Balance:",
  "vp.swap.panel.amountPlaceholder": "0.0",
  "vp.swap.detail.rate.label": "Rate",
  "vp.swap.detail.rate.same": "—",
  "vp.swap.detail.slippage.label": "Slippage tolerance",
  "vp.swap.detail.slippage.value": "0.50%",
  "vp.swap.detail.slippage.hint": "Max acceptable price movement before revert",
  "vp.swap.detail.priceImpact.label": "Price impact",
  "vp.swap.detail.networkFee.label": "Network fee",
  "vp.swap.detail.networkFee.suffix": "· Polygon",
  "vp.swap.detail.networkFee.hint": "Minimal — batched via Polygon zkEVM relayer",
  "vp.swap.detail.synergyBonus.label": "Ecosystem synergy bonus",
  "vp.swap.detail.minReceived.label": "Minimum received",
  "vp.swap.cta.routing": "Routing via Pando…",
  "vp.swap.cta.connectWallet": "Connect Web3 Wallet",
  "vp.swap.cta.selectDifferent": "Select different tokens",
  "vp.swap.cta.enterAmount": "Enter an amount",
  "vp.swap.cta.swap": "Swap Assets",
  "vp.swap.picker.eyebrowInput": "// Select input token",
  "vp.swap.picker.eyebrowOutput": "// Select output token",
  "vp.swap.liquidity.eyebrow": "// Pool Depth",
  "vp.swap.liquidity.stableBadge": "Stable",
  "vp.swap.liquidity.stat.pairDepth": "Pair depth",
  "vp.swap.liquidity.stat.volume24h": "24h volume",
  "vp.swap.liquidity.stat.feeTier": "Fee tier",
  "vp.swap.liquidity.stat.feeTierValue": "0.15%",
  "vp.swap.liquidity.stat.ecosystemTvl": "Ecosystem TVL",
  "vp.swap.liquidity.utilizationLabel": "Pool utilization by asset",
  "vp.swap.liquidity.poolsSuffix": "pools",
  "vp.swap.liquidity.disclaimer": "Internal liquidity is rebalanced hourly by the Pando router. Circulation stays inside the ecosystem — no external DEX exposure, no bridged wrappers.",
  "vp.swap.connectModal.eyebrow": "// Web3 Access",
  "vp.swap.connectModal.title": "Connect a wallet",
  "vp.swap.connectModal.body": "Connect to route liquidity across MEAL, Solar, Aqua, Planty and Village pools.",
  "vp.swap.connectModal.wallet.phantom.tag": "Solana + Polygon",
  "vp.swap.connectModal.wallet.metamask.tag": "Polygon zkEVM",
  "vp.swap.connectModal.wallet.walletconnect.tag": "300+ wallets",
  "vp.swap.connectModal.disclaimer": "Simulated connect · no keys exchanged",
  "vp.swap.success.eyebrow": "// Transaction Successful",
  "vp.swap.success.title": "Swap confirmed",
  "vp.swap.success.routedPrefix": "Routed",
  "vp.swap.success.txHashPrefix": "TxHash",
  "vp.swap.success.doneButton": "Done",
  "vp.swap.token.meal2.name": "Daily Utility Credit",
  "vp.swap.token.meal4.name": "Meal Anchor",
  "vp.swap.token.solar.name": "SolarPando Yield",
  "vp.swap.token.aqua.name": "AquaPando Reserves",
  "vp.swap.token.planty.name": "PlantyPando Land",
  "vp.swap.token.village.name": "VillagePando Governance",
  "nav.language": "Language",
  "vp.swap.pegged.badge": "1:1 USDC-backed voucher",
  "vp.swap.pegged.tooltip": "VillagePando is a 1:1 USDC-backed voucher; slippage and synergy math do not apply.",
  "vp.swap.tax.eyebrow": "SolarPando · transparency",
  "vp.swap.tax.title": "Where does the 5% go?",
  "vp.swap.tax.intro": "Every SolarPando transaction routes a flat 5% into physical hardware, reforestation, and network operations. The split below is defined in a single source of truth and mirrored 1:1 in the SFN audit documentation — the UI cannot drift.",
  "vp.swap.tax.total": "Total tax",
  "vp.swap.tax.perTx": "{pct}% of the transaction",
  "vp.swap.tax.hardware.label": "Hardware capex",
  "vp.swap.tax.hardware.detail": "Solar panels, batteries, inverters, EV chargers — RWA accumulation.",
  "vp.swap.tax.reforestation.label": "Reforestation",
  "vp.swap.tax.reforestation.detail": "Native trees geo-tagged and permanently attached to PLANTY collateral.",
  "vp.swap.tax.ops.label": "Operations",
  "vp.swap.tax.ops.detail": "Grid maintenance, monitoring, audit reporting, on-site staff.",
  "vp.nexus.trio.eyebrow": "Pando-Trio · directional flow",
  "vp.nexus.trio.caption": "Land feeds Water. Water feeds Power. Power buys back the Meal. Meals fund the Village.",
  "vp.nexus.trio.step1": "Land → Water",
  "vp.nexus.trio.step2": "Water → Power",
  "vp.nexus.trio.step3": "Power → Meal buyback",
  "vp.nexus.trio.step4": "Meals → Village",
  "nav.tokenomics": "Tokenomics",
  "nav.roadmap": "Roadmap",
  "nav.vision": "Vision",
  "nav.whitepaper": "Whitepaper",

  // Treasury transparency & purchase receipt
  "treasury.eyebrow": "Settlement transparency",
  "treasury.title": "Every MEAL2 & MEAL4 purchase settles to one treasury",
  "treasury.desc": "Purchases never route through a DEX or an intermediary wallet. The full destination address is shown on hover and verifiable on-chain before any button unlocks.",
  "treasury.label": "Project treasury",
  "treasury.network": "Network",
  "treasury.copy": "Copy address",
  "treasury.copied": "Copied",
  "treasury.explorer": "View on explorer",
  "treasury.status.checking": "Verifying destination",
  "treasury.status.verified": "Destination verified",
  "treasury.status.degraded": "Address valid · network busy",
  "treasury.status.invalid": "Destination unverified — purchases disabled",
  "receipt.eyebrow": "Transaction settled",
  "receipt.title": "Purchase confirmation",
  "receipt.desc": "Your contribution was routed to the SFN project treasury. Keep the signature below as your settlement reference.",
  "receipt.amount": "Paid",
  "receipt.received": "Received",
  "receipt.destination": "Treasury destination",
  "receipt.network": "Network",
  "receipt.hash": "Transaction signature",
  "receipt.viewExplorer": "View transaction on explorer",
  "receipt.close": "Close confirmation",
  "receipt.copyHash": "Copy hash",
  "receipt.hashCopied": "Hash copied",
  "receipt.download": "Download JSON",
  "rpc.checking": "Verifying network destination…",
  "rpc.degraded": "Network busy — address valid, on-chain check retried in background",
  "rpc.invalid": "Destination unverified — purchases disabled",

  // Analytics consent
  "consent.title": "Analytics consent",
  "consent.desc": "We use anonymous, cookie-free product analytics (no IP, no fingerprint) to improve this page. Nothing is sent until you accept.",
  "consent.accept": "Accept",
  "consent.decline": "Decline",
  "meal2.tab.web3": "Digital Swap (Web3)",

  // Storytelling upgrades
  "arch.eyebrow": "Ecosystem Architecture",
  "arch.title": "How value flows through the network",
  "arch.sub": "Five connected layers turn on-chain tokens into a real plate of food — and back into verifiable data.",
  "arch.n1.t": "MEAL2 & MEAL4 Tokens",
  "arch.n1.d": "MEAL4 stores value (1,000,000 hard cap). MEAL2 circulates as the daily meal unit.",
  "arch.n2.t": "Local Kitchens & Restaurants",
  "arch.n2.d": "Certified partner kitchens accept MEAL2 and serve a full meal at a fixed 30 THB.",
  "arch.n3.t": "Direct Farmers & Supply Chain",
  "arch.n3.d": "Kitchens buy straight from regional farms — no middlemen, fair prices, short routes.",
  "arch.n4.t": "Consumers / Web3 Wallet",
  "arch.n4.d": "Diners hold and spend from their own wallet; every meal settles on Solana in under a second.",
  "arch.n5.t": "AI Analytics & Carbon Credits",
  "arch.n5.d": "Demand, sourcing and energy data feed forecasting and verifiable carbon credit reporting.",
  "trustpilot.eyebrow": "Proof of Concept · Pilot Region",
  "trustpilot.title": "Proven in Thailand — Expanding Globally.",
  "trustpilot.desc": "Our anchor kitchen and community hub are already operating. Every mechanism you read about here is tested on real plates, real farmers and real settlements before it scales.",
  "trustpilot.b1": "Anchor kitchen operating daily",
  "trustpilot.b2": "Regional farmer network",
  "trustpilot.b3": "Solar-powered community hub",
  "trustpilot.b4": "On-chain settlement live",
  "bento.card1.b1": "Certified partner kitchens & local farmers",
  "bento.card1.b2": "Community funded, solar powered",
  "bento.card1.b3": "Costs kept low and stable",
  "bento.card2.b1": "Direct sourcing — no middlemen",
  "bento.card2.b2": "Short routes, fresh produce",
  "bento.card2.b3": "Fair, predictable farm-gate prices",
  "bento.card3.b1": "Real estate & real assets as backing",
  "bento.card3.b2": "Quarterly proof-of-reserves",
  "bento.card3.b3": "Transparent on-chain supply",
  "story.kitchen.alt": "Cooks plating fresh meals in a local partner kitchen",
  "story.farmer.alt": "Local farmer holding a crate of freshly harvested vegetables",
  "story.diners.alt": "Guests sharing a healthy meal and paying at a local restaurant",
  "story.pilot.alt": "Solar-powered community hub in the Thai pilot region",

  "loop.eyebrow": "Circular Impact Loop",
  "loop.title": "The Closed-Loop Food & Infrastructure Economy",
  "loop.sub": "Eight steps, one circle. Value created at the table flows back into the fields, the village and the grid that made the meal possible.",
  "loop.step": "Step",
  "loop.footnote": "Every step settles on-chain — auditable end to end.",
  "loop.s1.t": "Farmer / Supply",
  "loop.s1.d": "Local farms deliver directly to the network at fair, pre-agreed farm-gate prices — no middlemen, short routes, fresh produce.",
  "loop.s2.t": "Local Restaurant / Kitchen",
  "loop.s2.d": "Certified partner kitchens turn that produce into complete, healthy meals under shared quality and cost standards.",
  "loop.s3.t": "MealToken / 30 THB Price Freeze",
  "loop.s3.d": "A meal is redeemed against a token, not a menu price. The 30 THB entitlement is fixed on-chain and cannot be inflated away.",
  "loop.s4.t": "Customer / Wallet",
  "loop.s4.d": "Diners hold their meal entitlements in their own Solana wallet and settle in under a second, without a bank account.",
  "loop.s5.t": "Impact Fund & Rewards",
  "loop.s5.d": "A fixed share of every settlement routes into the transparent impact treasury and back to contributors as rewards.",
  "loop.s6.t": "Village Infrastructure",
  "loop.s6.d": "The treasury funds physical micro-infrastructure: kitchens, cold storage, food hubs and community facilities.",
  "loop.s7.t": "Solar & Water Energy",
  "loop.s7.d": "Solar generation and clean water systems cut the running cost of every kitchen and every hectare in the network.",
  "loop.s8.t": "Sustainable Yield / Farmers",
  "loop.s8.d": "Cheaper energy and water raise farm yields and incomes — which feeds the next cycle of the loop at an even lower cost base.",

  "synergy.eyebrow": "Brand Synergy",
  "synergy.body": "MealToken24 is the utility & payment engine powering VillagePando — our physical and digital Impact-Tech infrastructure for sustainable food, energy, and water.",
  "synergy.b1": "MealToken24 · payments & price freeze",
  "synergy.b2": "VillagePando · physical impact infrastructure",
  "synergy.b3": "One treasury, one on-chain ledger",

  "phase1.eyebrow": "Where We Start · Phase 1",
  "phase1.title": "Phase 1 Launch: Pilot Kitchen Network & Smart Food Hub in the Thailand Sandbox.",
  "phase1.body": "Before the network scales, everything is proven in one region: an operating anchor kitchen, a regional farmer circle and a solar-powered community hub. These are the numbers we run and grow against.",
  "phase1.imgAlt": "Solar-powered village home in the Thai pilot region at sunset",
  "phase1.kpiNote": "Live pilot figures & Phase 1 targets — updated with each quarterly report.",
  "phase1.k1.label": "Meals Served",
  "phase1.k1.note": "Since pilot start",
  "phase1.k2.label": "Partner Kitchens",
  "phase1.k2.note": "Phase 1 target",
  "phase1.k3.label": "Solar Yield",
  "phase1.k3.note": "Annualised",
  "phase1.k4.label": "Active Villages",
  "phase1.k4.note": "Thailand Sandbox",

  "why.eyebrow": "Why On-Chain?",
  "why.title": "Why does food security need a token at all?",
  "why.body": "100% immutable price stabilisation, transparent fund allocation to direct farmers, and trustless governance for micro-infrastructure — three things a spreadsheet and a bank account cannot guarantee.",
  "why.w1.t": "Immutable price stabilisation",
  "why.w1.d": "The 30 THB meal entitlement lives in a smart contract with a hard-capped supply. No operator can quietly reprice it.",
  "why.w2.t": "Transparent farmer funding",
  "why.w2.d": "Every baht routed to farms and kitchens is traceable on Solana — donors and investors verify allocation themselves.",
  "why.w3.t": "Trustless micro-governance",
  "why.w3.d": "Village infrastructure decisions and treasury releases are executed by contract rules, not by a single signature.",
  "vp.solar.imgAlt": "Solar panels on a village home in the Thai pilot region",
  "vp.planty.imgAlt": "Local farmer holding freshly harvested vegetables",
  "vp.aqua.imgAlt": "Clean irrigation water flowing into a green vegetable field",
  "hero.title": "Freezing the Price of Food: A Healthy Meal for $1 — Forever.",
  "hero.sub": "Simple utility. Real infrastructure. Powered by Meal2 and Meal4.",
  "hero.badge": "The world's first dual-token food infrastructure — hedging against food inflation, one $1 meal at a time.",
  "hero.cta": "Buy Meal2 ($1 Meal)",
  "hero.ghost": "Get Meal4 (Governance)",
  "keep.title": "How We Keep Meals at $1",
  "keep.sub": "Three real-world assets absorb the cost pressure so the plate price never moves.",
  "keep.solar.title": "Solar Energy",
  "keep.solar.text": "Off-grid solar powers every kitchen, removing electricity bills from the cost of a meal.",
  "keep.agri.title": "Agriculture",
  "keep.agri.text": "Direct farm sourcing and reforestation lock in ingredient costs without middlemen.",
  "keep.water.title": "Clean Water",
  "keep.water.text": "Filtered water reservoirs secure daily production through dry seasons at zero variable cost.",
  "brand.tagline": "The $1 Food Engine",
  "nav.product": "Product",
  "nav.pilot": "Pilot Kitchens",
  "swap.quote.title": "Live route quote",
  "swap.quote.slippage": "Max slippage",
  "swap.quote.expiry": "Quote expiry",
  "swap.quote.minReceive": "Minimum received",
  "swap.quote.usdValue": "Estimated value",
  "swap.quote.expiresIn": "Refreshes in {s}s",
  "swap.quote.expired": "Quote expired — refresh to continue",
  "swap.quote.refresh": "Refresh quote",
  "swap.quote.expiredError": "Your quote expired. Please refresh the rate and try again.",
  "swap.quote.slippageError": "The SOL rate moved beyond your slippage limit. Nothing was signed.",
  "verify.badge": "Proof of purchase",
  "verify.title": "Verify my receipt",
  "verify.intro": "Paste your Solana transaction signature to confirm your purchase directly against the network and the SFN ledger. Verification runs server-side — no wallet connection needed.",
  "verify.modalIntro": "Server-verified on-chain status plus your matching ledger entry.",
  "verify.label": "Transaction signature",
  "verify.placeholder": "Paste your Solana transaction signature",
  "verify.submit": "Verify receipt",
  "verify.busy": "Verifying…",
  "verify.close": "Close receipt verification",
  "verify.verified": "Verified on-chain",
  "verify.unreachable": "Network unreachable — retry shortly",
  "verify.notConfirmed": "Not confirmed",
  "verify.invalid": "That is not a valid Solana signature.",
  "verify.rateLimited": "Too many lookups. Please wait a minute and try again.",
  "verify.replay": "You already checked this signature in this session.",
  "verify.error": "Verification service is busy. Please try again in a moment.",
  "verify.receiptId": "Receipt ID",
  "verify.signature": "Signature",
  "verify.ledgerEntry": "Ledger entry",
  "verify.purchase": "Purchase",
  "verify.value": "Value",
  "verify.wallet": "Wallet",
  "verify.checks": "Settlement checks",
  "verify.noLedger": "No matching SFN ledger entry for this signature yet. If you just paid, wait a few seconds and check again.",
  "verify.explorer": "View on Solscan",
  "admin.csv.export": "Download CSV",
  "admin.csv.exportLabel": "Download the sales ledger as a CSV file",
  "dexRoadmap.title": "Roadmap towards Liquidity & Indexing",
  "dexRoadmap.phase1": "Presale & Utility Launch",
  "dexRoadmap.phase2": "Jupiter Strict List & Raydium Liquidity Pool",
  "dexRoadmap.phase3": "CoinGecko & CoinMarketCap Token Indexing",
  "dexRoadmap.active": "Active",
  "dexRoadmap.status.active": "Active",
  "dexRoadmap.status.next": "Next",
  "dexRoadmap.status.planned": "Planned",
  "dexRoadmap.statusLive": "Roadmap phase status is live.",
  "dexRoadmap.statusFallback": "Live roadmap status unavailable — showing the published plan.",
  "dexRoadmap.visit": "Open {name} in a new tab",
  "swap.quote.refreshing": "Refreshing rate…",
};
